import { StaticResource } from '@lib/iab/iab-vast-model';

interface IStaticResource {
    creativeType: string;
    _value: string;
}

const createStaticResource = (
    $staticResource: IStaticResource
): StaticResource => {
    const res = new StaticResource();
    res.creativeType = $staticResource.creativeType;
    res.uri = $staticResource._value;
    return res;
};

export default createStaticResource;
